export const AriaLabel = {
  Menu: 'Menu',
  LeftChevron: 'Previous page',
  RightChevron: 'Next page'
};
